import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { DropdownItem } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { FormSelectField, LocalizedText, useLocalizeEnum } from '@mews/framework';
import { RateType } from '@mews-commander/data-access';
import { values } from '@mews/fp';
import { LockableField } from '../../LockableField';
import { RATE_TYPE_FIELD_NAME } from './fieldNames';
import { getFieldLockedConfig } from './helpers';
import { WithFieldsConfig } from './types';

type RateTypeFieldProps = WithFieldsConfig & {
    onUnlock?: () => void;
};

export const RateTypeField = ({ fieldsConfig, onUnlock }: RateTypeFieldProps) => {
    const localizeEnum = useLocalizeEnum();

    const rateTypeValues = pipe(
        RateType,
        values,
        array.filter((value) => value !== RateType.AvailabilityBlock)
    );

    const renderRateTypeItems = () =>
        pipe(
            rateTypeValues,
            array.map((value) => <DropdownItem key={value} value={value} label={localizeEnum('RateType', value)} />)
        );
    return (
        <LockableField
            fieldName={RATE_TYPE_FIELD_NAME}
            locked={getFieldLockedConfig(RATE_TYPE_FIELD_NAME, fieldsConfig)}
            lockedReasonText={TextKey.RatesValuesAreDifferent}
            tooltipTextKey={TextKey.UnlockableRatesField}
            onUnlock={onUnlock}
        >
            {(isLocked) => (
                <FormSelectField
                    name={RATE_TYPE_FIELD_NAME}
                    label={<LocalizedText textKey={TextKey.RateVisibility} />}
                    disabled={isLocked}
                    required
                >
                    {renderRateTypeItems()}
                </FormSelectField>
            )}
        </LockableField>
    );
};
